import React, { useEffect, useState } from 'react'
import './style.css'
import axios from 'axios'
import getServerURL from '../../../functions/getServerURL'
import LoadingAnimation from '../../../reuseable-components/LoadingAnimation'
import { NavLink, useHistory, useParams } from 'react-router-dom'
import { Alert, Button, ControlLabel } from 'react-bootstrap'
import { Typeahead } from 'react-bootstrap-typeahead'
import Materials from "./Materials";


export default function QMSTrainingContainer() {
  // REACT ROUTER DOM
  const params = useParams()
  const history = useHistory()

  // STATE
  const [loading, setLoading] = useState(false)
  const [loadingTraining, setLoadingTraining] = useState(false)
  const [trainings, setTrainings] = useState([])
  const [selectedTraining, setSelectedTraining] = useState(null)
  const [knowledgeAssessment, setKnowledgeAssessment] = useState(null)

  const getTrainings = () => {
    setLoading(true)
    axios.get(`${getServerURL()}trainings/`, {
      params: { is_published: true, is_active: true },
      headers: { "Authorization": `Bearer ${ localStorage.getItem("token") }` }
    }).then(response => {
      setTrainings(response.data.sort((a,b) => {
        // SORTS TRAININGS SO THE ASSIGNED ONES ARE SHOWED FIRST
        if (a.is_assigned && !b.is_assigned) {
          return -1
        } else if (!a.is_assigned && b.is_assigned) {
          return 1
        } else {
          return 0
        }
      }))
    }).catch(error => {
      console.log(error)
    }).then(() => {
      setLoading(false)
    })
  }

  const getTraining = (id) => {
    setLoadingTraining(true)
    axios.get(`${getServerURL()}trainings/${id}/get_training_and_assignment/`, {
      params: { is_published: true },
      headers: { "Authorization": `Bearer ${ localStorage.getItem("token") }` }
    }).then(response => {
      if (!selectedTraining) {
        setSelectedTraining(response.data.training)
        setKnowledgeAssessment(response.data.result)
      }
    }).catch(error => {
      if (error.response && error.response.status === 404) {
        history.replace("/trainings")
      }
    }).then(() => {
      setLoadingTraining(false)
    })
  }

  const selectTraining = (trainingArray) => {
    if (!trainingArray.length) {
      setSelectedTraining(null)
      history.replace("/trainings")
      return
    }
    const trainingObject = trainingArray[0]
    history.replace(`/trainings/${trainingObject.id}`)
    setSelectedTraining(trainingObject)
    getTraining(trainingObject.id)
  }

  const renderSelectedTraining = () => {
    if (!selectedTraining && !loadingTraining) {
      return <h4>Please select a training.</h4>
    }
    return (
      loadingTraining ?
        <LoadingAnimation />
        :
        <div>
          <h3>{ selectedTraining && selectedTraining.name }</h3>
          <Materials selectedTraining={ selectedTraining } />
          { knowledgeAssessment &&
            <div>
              { knowledgeAssessment.message ?
                <Alert bsStyle="success">
                  { knowledgeAssessment.message }
                  <a style={{ float: "right" }} href={ knowledgeAssessment.certificate } target="_blank">View Certificate</a>
                </Alert>
                :
                <Alert bsStyle={ knowledgeAssessment.status === "Not Taken" ? "info" : "danger" }>
                  { knowledgeAssessment.status === "Not Taken" ?
                    <p>The knowledge assessment has not been taken yet.</p>
                    :
                    <p>The knowledge assessment has been failed the last time it was taken. Please try again.</p>
                  }
                  <br/>
                  <NavLink to={`/trainings/${selectedTraining.id}/assessment`}>
                      <Button>Knowledge Assessment</Button>
                  </NavLink>
                </Alert>
              }
            </div>
          }
        </div>
    )
  }

  const _renderMenuItemChildren = (training, props, index) => {
    return [
      <div key="name" search={props.text}>
        <strong>{training.name}</strong>
      </div>,
      <div key="population">
        <small>
          { training.is_assigned && training.is_assigned }
          { !training.is_assigned && "Training not assigned." }
        </small>
      </div>,
    ]
  }

  useEffect(() => {
    getTrainings(1)
    if (params.id) {
      getTraining(params.id)
    }
  }, [])

  return (
    <div id="QMSTrainingContainer">
      { loading ?
        <LoadingAnimation />
        :
        <div>
          <center>
            <div className="form-input-container">
              <ControlLabel>
                Select Training
              </ControlLabel>
              <Typeahead
                style={{ margin: "25px" }}
                renderMenuItemChildren={_renderMenuItemChildren}
                id='SelectTrainingTypeahead'
                labelKey={ training => training.name }
                options={ trainings }
                selected={ selectedTraining ? [ selectedTraining ] : [] }
                onChange={ selectTraining }
                placeholder="Select training"
              />
            </div>
          </center>
          { renderSelectedTraining() }
        </div>
      }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTraining/index.js